// import React, { useContext } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { AuthContext } from "../../context/AuthContext";

// export default function Navbar() {
//   const { user, logout } = useContext(AuthContext);
//   const nav = useNavigate();

//   function handleLogout() {
//     logout();
//     nav("/");
//   }

//   return (
//     <header className="bg-white border-b">
//       <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
//         {/* Logo / brand */}
//         <div className="flex items-center gap-2">
//           <Link to="/" className="flex items-center gap-2">
//             <img src="/roomvetiyo.png" alt="RoomVetiyo" className="w-30 h-10" />
//             {/* <span className="w-8 h-8 rounded-xl bg-[#FF4A1F]/10 flex items-center justify-center text-[#FF4A1F] font-bold text-lg">
//               R
//             </span>
//             <span className="font-bold text-lg text-gray-900">
//               RoomVetiyo
//             </span> */}
//           </Link>
//         </div>

//         {/* Middle navigation */}
//         <nav className="hidden md:flex items-center gap-6 text-sm">
//           <Link to="/" className="text-gray-700 hover:text-[#FF4A1F]">
//             Home
//           </Link>
//           <Link to="/search" className="text-gray-700 hover:text-[#FF4A1F]">
//             Find Rooms
//           </Link>

//           {/* {user?.role === "OWNER" && (
//             <Link to="/owner" className="text-gray-700 hover:text-[#FF4A1F]">
//               Owner Dashboard
//             </Link>
//           )} */}

//           {/* Owner Dashboard */}
//           {user?.role === "OWNER" && (
//             <>
//               <Link
//                 to="/owner"
//                 className="text-gray-700 hover:text-[#FF4A1F]"
//               >
//                 Owner Dashboard
//               </Link>

//               {/* ⭐ Add Room Link (NEW) */}
//               <Link
//                 to="/add-listing"
//                 className="text-gray-700 hover:text-[#FF4A1F]"
//                 // className="text-sm px-3 py-1.5 rounded-lg bg-[#FF4A1F] text-white shadow hover:bg-[#e43d13]"
//               >
//                 Add Room
//               </Link>
//             </>
//           )}

//           {user?.role === "SEEKER" && (
//             <Link to="/seeker" className="text-gray-700 hover:text-[#FF4A1F]">
//               My Dashboard
//             </Link>
//           )}
//           {user?.role === "ADMIN" && (
//             <Link to="/admin" className="text-gray-700 hover:text-[#FF4A1F]">
//               Admin Panel
//             </Link>
//           )}
//         </nav>

//         {/* Right side: auth actions */}
//         <div className="flex items-center gap-3">
//           {!user ? (
//             <>
//               <Link
//                 to="/login"
//                 className="text-sm text-gray-700 hover:text-[#FF4A1F]"
//               >
//                 Login
//               </Link>
//               <Link
//                 to="/register"
//                 className="px-3 py-1.5 rounded-lg bg-[#FF4A1F] text-white text-sm shadow-sm"
//               >
//                 Sign Up
//               </Link>
//             </>
//           ) : (
//             <div className="flex items-center gap-3">
//               <div className="text-sm text-gray-700">
//                 {user.fullName || user.email}
//               </div>
//               <button
//                 onClick={handleLogout}
//                 className="text-sm text-gray-500 hover:text-red-500"
//               >
//                 Logout
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </header>
//   );
// }

import React, { useContext } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";

export default function Navbar() {
  const { user, logout } = useContext(AuthContext);
  const nav = useNavigate();

  function handleLogout() {
    logout();
    nav("/");
  }

  const role = user?.role; // "ADMIN" | "OWNER" | "SEEKER" | undefined

  // Build nav links based on role
  const navLinks = [];

  // Home is always present
  navLinks.push({ to: "/", label: "Home" });

  if (!role) {
    // Not logged in
    navLinks.push(
      { to: "/search", label: "Find Home" },
      { to: "/terms", label: "Terms & Conditions" },
      { to: "/aboutus", label: "About US" },
      { to: "/contact", label: "Contact" },
      { to: "/roomInquiry", label: "Room Inquiry" },
    );
  } else if (role === "ADMIN") {
    // Admin: Home + Admin Dashboard
    navLinks.push({ to: "/admin", label: "Admin Dashboard" });
  } else if (role === "OWNER") {
    // Owner: Home, OwnerDashboard, AddRoom, Terms
    navLinks.push(
      { to: "/owner", label: "Owner Dashboard" },
      { to: "/add-listing", label: "Add Room" },
      { to: "/terms", label: "Terms & Conditions" },
    );
  } else if (role === "SEEKER") {
    // Student/Seeker: Home, Find Home, Seeker Dashboard, Terms
    navLinks.push(
      { to: "/search", label: "Find Home" },
      { to: "/seeker", label: "Seeker Dashboard" },
      { to: "/terms", label: "Terms & Conditions" },
    );
  }

  return (
    <header className="bg-white border-b">
      <div className="max-w-7xl mx-auto px-6 py-1 flex items-center justify-between">
        {/* Logo / brand */}
        <div className="flex items-center gap-2">
          <Link to="/" className="flex items-center gap-2">
            <img src="/roomvetiyo.png" alt="RoomVetiyo" className="w-30 h-10" />
          </Link>
        </div>

        {/* Middle navigation */}
        {/* <nav className="hidden md:flex items-center gap-6 text-sm">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="text-gray-700 hover:text-[#FF4A1F]"
            >
              {link.label}
            </Link>
          ))}
        </nav> */}
        <nav className="hidden md:flex items-center gap-2 text-sm">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === "/"}
              className={({ isActive }) =>
                `px-4 py-2 rounded-lg font-medium transition-all duration-200 ${
                  isActive
                    ? "bg-[#FF4A1F] text-white shadow-md"
                    : "text-gray-700 hover:bg-orange-50 hover:text-[#FF4A1F]"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        {/* Right side: auth actions */}
        <div className="flex items-center gap-3">
          {!user ? (
            <>
              <Link
                to="/login"
                // className="text-sm text-gray-700 hover:text-[#FF4A1F]"
                className="px-3 py-1.5 rounded-lg bg-[#FF4A1F] text-white text-sm shadow-sm"
              >
                Login
              </Link>
              {/* <Link
                to="/register"
                className="px-3 py-1.5 rounded-lg bg-[#FF4A1F] text-white text-sm shadow-sm"
              >
                Sign Up
              </Link> */}
            </>
          ) : (
            <div className="flex items-center gap-3">
              <div className="text-sm text-gray-700">
                {user.fullName || user.email}
              </div>
              <button
                onClick={handleLogout}
                className="text-sm text-gray-500 hover:text-red-500"
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
